import { FieldRequiredType } from '@ovComponents/4-module/configurableOptionFields/basicField';

export const showsRequiredFieldError = ({
  missing,
  field,
  focused,
  requirement,
}: {
  missing: boolean;
  field: string;
  focused: string[];
  requirement?: FieldRequiredType;
}) =>
  missing &&
  focused.includes(field) &&
  requirement !== FieldRequiredType.NOT_REQUIRED;
